module.exports = {
  id: 23,
  name: 'Plank',
  categories: ['strength', 'core', 'balance'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 12,
  instructions:
    'Plank makes your core strong! Get on your hands and knees, extend your legs out, and rest on your forearms. Keep your body straight like a board, and hold that position!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to hold like a board? Let us build incredible core strength!',
    },
    {
      time: 3,
      text: 'Get on your hands and knees, extend your legs out, and rest on your forearms!',
    },
    {
      time: 6,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Hold steady and breathe deeply!',
    },
    // SET 1 - 20 seconds
    {
      time: 12,
      text: 'Perfect plank position! Keep your body straight like a board!',
    },
    {
      time: 15,
      text: 'Engage your core muscles, hold steady and breathe!',
    },
    {
      time: 18,
      text: 'Keep your body in a straight line, you are doing great!',
    },
    {
      time: 21,
      text: 'Hold steady, 15 seconds remaining, stay strong!',
    },
    {
      time: 24,
      text: 'Keep your core engaged, breathe deeply and stay focused!',
    },
    {
      time: 27,
      text: 'Hold steady, 10 seconds remaining, you are strong!',
    },
    {
      time: 30,
      text: 'Keep your body straight, 5 seconds remaining, almost there!',
    },
    {
      time: 33,
      text: 'Great job! Take a deep breath and shake out your core.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 36,
      text: 'Take a deep breath in and out, you are building incredible core strength!',
    },
    {
      time: 39,
      text: 'Shake out your arms and legs, get ready for round two!',
    },
    {
      time: 42,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 45,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 25 seconds
    {
      time: 48,
      text: 'Get on your hands and knees, extend your legs out, and rest on your forearms!',
    },
    {
      time: 51,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 54,
      text: 'Perfect plank position! Hold steady and breathe deeply!',
    },
    {
      time: 57,
      text: 'Engage your core muscles, you are building strength!',
    },
    {
      time: 60,
      text: 'Keep your body in a straight line, stay focused!',
    },
    {
      time: 63,
      text: 'Hold steady, 20 seconds remaining, you are doing great!',
    },
    {
      time: 66,
      text: 'Keep your core engaged, breathe deeply and stay strong!',
    },
    {
      time: 69,
      text: 'Hold steady, 15 seconds remaining, keep going!',
    },
    {
      time: 72,
      text: 'Keep your body straight, 10 seconds remaining, stay focused!',
    },
    {
      time: 75,
      text: 'Hold steady, 5 seconds remaining, you are strong!',
    },
    {
      time: 78,
      text: 'Great job! Take a deep breath and shake out your core.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 81,
      text: 'Take a deep breath in and out, you are building incredible core strength!',
    },
    {
      time: 84,
      text: 'Shake out your arms and legs, get ready for round three!',
    },
    {
      time: 87,
      text: 'You are doing amazing! Ready for round three? Let us keep going!',
    },
    {
      time: 90,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 30 seconds
    {
      time: 93,
      text: 'Get on your hands and knees, extend your legs out, and rest on your forearms!',
    },
    {
      time: 96,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 99,
      text: 'Perfect plank position! Hold steady and breathe deeply!',
    },
    {
      time: 102,
      text: 'Engage your core muscles, you are building incredible strength!',
    },
    {
      time: 105,
      text: 'Keep your body in a straight line, stay focused and strong!',
    },
    {
      time: 108,
      text: 'Hold steady, 25 seconds remaining, you are doing great!',
    },
    {
      time: 111,
      text: 'Keep your core engaged, breathe deeply and stay focused!',
    },
    {
      time: 114,
      text: 'Hold steady, 20 seconds remaining, keep going!',
    },
    {
      time: 117,
      text: 'Keep your body straight, 15 seconds remaining, stay strong!',
    },
    {
      time: 120,
      text: 'Hold steady, 10 seconds remaining, you are amazing!',
    },
    {
      time: 123,
      text: 'Keep your core engaged, 5 seconds remaining, almost there!',
    },
    {
      time: 126,
      text: 'Hold steady, final seconds, you are incredible!',
    },
    {
      time: 129,
      text: 'Great job! Take a deep breath and shake out your core.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 132,
      text: 'Take a deep breath in and out, you are building incredible core strength!',
    },
    {
      time: 135,
      text: 'Shake out your arms and legs, get ready for the final round!',
    },
    {
      time: 138,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 141,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 4 - 30 seconds
    {
      time: 144,
      text: 'Get on your hands and knees, extend your legs out, and rest on your forearms!',
    },
    {
      time: 147,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 150,
      text: 'Perfect plank position! Hold steady and breathe deeply!',
    },
    {
      time: 153,
      text: 'Engage your core muscles, you are building incredible strength!',
    },
    {
      time: 156,
      text: 'Keep your body in a straight line, stay focused and strong!',
    },
    {
      time: 159,
      text: 'Hold steady, 25 seconds remaining, you are doing great!',
    },
    {
      time: 162,
      text: 'Keep your core engaged, breathe deeply and stay focused!',
    },
    {
      time: 165,
      text: 'Hold steady, 20 seconds remaining, keep going!',
    },
    {
      time: 168,
      text: 'Keep your body straight, 15 seconds remaining, stay strong!',
    },
    {
      time: 171,
      text: 'Hold steady, 10 seconds remaining, you are amazing!',
    },
    {
      time: 174,
      text: 'Keep your core engaged, 5 seconds remaining, almost there!',
    },
    {
      time: 177,
      text: 'Hold steady, final seconds, you are incredible!',
    },
    {
      time: 180,
      text: 'Incredible work! You are done! You just completed all four sets!',
    },
    // COMPLETION
    {
      time: 183,
      text: 'Amazing work! You held plank for over 2 minutes total!',
    },
    {
      time: 186,
      text: 'Your core is getting super strong! You are a plank master!',
    },
    {
      time: 189,
      text: 'Great job, core champion! You are building incredible strength!',
    },
  ],
};
